module.exports = __webpack_public_path__ + "img/welfare-ico-1.50d7e823.png";